module.exports = __webpack_public_path__ + "static2023-4-17/img/user.c4eb8254.png";